module.exports = __webpack_public_path__ + "media/images/carrito-cbdfb922478e7346119aa3f7c7565a12.png";